import { render, staticRenderFns } from "./JeecgDemoModal.vue?vue&type=template&id=1852ae1a&scoped=true&"
import script from "./JeecgDemoModal.vue?vue&type=script&lang=js&"
export * from "./JeecgDemoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852ae1a",
  null
  
)

export default component.exports